module.exports = __webpack_public_path__ + "static/angular-e224f5ed261735072b00bdb3bae20cbd.svg";